import Steps from './Steps';

export * from 'rc-steps';

export default Steps;
